import React from 'react';
import { AutocompleteGlobalStyles } from '@components/moleculs/autocomplete/global-styles';
import { DatePickerGlobalStyles } from '@components/moleculs/date-pickers/global-styles';
import { TooltipGlobalStyles } from '@components/moleculs/tooltip/global-styles';
import { TimerGlobalStyles } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/start/timer';

import { WidgetGlobalStyles } from './widget-global-styles';

export const GlobalStyles = () => (
    <React.Fragment>
        <WidgetGlobalStyles />
        <AutocompleteGlobalStyles />
        <TooltipGlobalStyles />
        <TimerGlobalStyles />
        <DatePickerGlobalStyles />
    </React.Fragment>
);
